import { Accordion } from '../utils/Accordion';

const accordionTemplate = (id, title, body, isPRS = true, name = 'contribution', titleLevel = 'h3') => {
    return `
        <div id="${id}" class="${isPRS ? 'container-grid ' : '' }paragraphe txt accordion-wrapper">
            <div class="paragraphe__inner">
                <div class="c-accordion">
                    <${titleLevel} class="c-accordion__heading">
                        <button class="c-accordion__button js-accordion" aria-expanded="false" aria-controls="accordion-${id}" id="btn-${id}" data-name="${name}">
                            ${title}
                            <i class="o-icon o-icon--form-chevron-down o-icon--color-primary" aria-hidden="true"></i>
                        </button>
                    </${titleLevel}>
                    <div class="c-accordion__content" id="accordion-${id}" role="region" aria-labelledby="btn-${id}">
                        <div class="c-accordion__body">
                            ${body}
                        </div>
                    </div>
                </div>
            </div>
        </div>`;
};

let titleLevel = 'h3';
// Récupération de tous les styles de paragraphe "accordéon"
const paragraphes = document.querySelectorAll('.PRS_PLIER, .js-accordion');
paragraphes.forEach((paragraphe, index) => {

    // On récupère l'id du paragraphe
    const id = paragraphe.id;
    // Vérifie si l'élément précédent est aussi un accordéon
    const previousElement = paragraphe.previousElementSibling;
    const isPartOfSequence = previousElement && previousElement.classList.contains('accordion-wrapper');

    // Si c'est une nouvelle séquence, récupérer le titre qui précède ce paragraphe
    if (!isPartOfSequence) {
        // Recherche du titre avant la séquence (H1 - H6)
        const previousTitleElement = previousElement?.childNodes[0].childNodes[0]?.nodeName;
        // Affiche le niveau du titre si trouvé
        const previousTitleLevel = previousElement ? previousTitleElement : 'Pas de titre';
        // On ne dynamise que pour un h4 si h3 et le niveau de titre précédent
        titleLevel = (previousTitleLevel === "H3") ? "h4" : "h3";
    }

    // Si c'est le début d'une nouvelle séquence, on crée un nouveau nom
    // Sinon on utilise le data-name de l'accordéon précédent
    const name = isPartOfSequence
        ? previousElement.querySelector('.js-accordion').getAttribute('data-name')
        : 'contribution-' + index;
    // On récupère le titre et le contenu du paragraphe stocké dans un tableau
    const currentFullBody = [...paragraphe.querySelectorAll('.paragraphe__inner > *')];
    // On extrait le titre principal (et au passage shift() va supprimer le 1er <h2> du tableau)
    const currentTitle = currentFullBody.shift().innerHTML;
    // On récupère les contenus du paragraphe
    const currentBody = currentFullBody.map(el => el.outerHTML).join('');
    // Initialisation depuis un style de paragraphe ou manuellement avec la classe js-accordion
    const isPRS = paragraphe.classList.contains('PRS_PLIER');

    // On insère le template à la suite du paragraphe initial
    paragraphe.insertAdjacentHTML('afterend', accordionTemplate(id, currentTitle, currentBody, isPRS, name, titleLevel));
    // On supprime le paragraphe original
    paragraphe.remove();
});

document.addEventListener('DOMContentLoaded', () => {
    const accordions = document.querySelectorAll('.js-accordion');
    // On initialise chaque accordion avec la classe Accordion (qui étend Disclosure)
    accordions.forEach(accordion => {
        const accordionClass = new Accordion(accordion);
        accordionClass.init();
    });
});
